import axios, { CancelToken } from "axios";
import { CANCEL } from "redux-saga";

import * as env from "./../config/env";
import AppError from "./../ultis/AppError";

let token, lang;
axios.defaults.baseURL = env.SERVER;
axios.defaults.headers.post["Content-Type"] = "application/json";
axios.defaults.headers.common["Accept"] = "application/json";

const baseConfig = {
  transformResponse: [
    (data) => {
      const _data = JSON.parse(data);
      if (_data.code !== 200) {
        throw new AppError(_data, _data.message);
      }
      return _data;
    },
  ],
};

const headersConfig = () => {
  if (token) {
    return {
      "x-api-key": token,
    };
  }
  return {};
};

export const get = (url) => {
  const source = CancelToken.source();
  const headers = headersConfig();
  const req = axios.get(url, {
    headers,
    cancelToken: source.token,
  });
  req[CANCEL] = () => source.cancel();
  return req;
};

export const post = (url, data) => {
  console.log(data);
  const source = CancelToken.source();
  const headers = headersConfig();
  const req = axios.post(url, data, {
    headers,
    cancelToken: source.token,
  });
  req[CANCEL] = () => source.cancel();
  return req
    .then((rs) => {
      console.log(rs);
      return rs;
    })
    .catch((e) => {
      throw new AppError(e, e.message);
    });
};

export const put = (url, data) => {
  console.log(data);
  const source = CancelToken.source();
  const headers = headersConfig();
  const req = axios.put(url, data, {
    headers,
    cancelToken: source.token,
  });
  req[CANCEL] = () => {
    source.cancel();
  };
  return req
    .then((rs) => {
      return rs;
    })
    .catch((e) => {
      throw new AppError(e, e.message);
    });
};

export const del = (url) => {
  console.log(url);
  const source = CancelToken.source();
  const headers = headersConfig();
  const req = axios.delete(url, {
    headers,
    cancelToken: source.token,
  });
  req[CANCEL] = () => source.cancel();
  return req;
};

export const setToken = (newToken) => {
  token = newToken;
};

export const setLang = (_lang) => {
  lang = _lang;
};

export const getLang = () => {
  return lang;
};
